__turbopack_context__.v({
  "button": "tour-selector-module-scss-module__dNxM5q__button",
  "buttonContent": "tour-selector-module-scss-module__dNxM5q__buttonContent",
  "buttonLabel": "tour-selector-module-scss-module__dNxM5q__buttonLabel",
  "buttonText": "tour-selector-module-scss-module__dNxM5q__buttonText",
  "buttonsContainer": "tour-selector-module-scss-module__dNxM5q__buttonsContainer",
  "container": "tour-selector-module-scss-module__dNxM5q__container",
  "icon": "tour-selector-module-scss-module__dNxM5q__icon",
  "skipLink": "tour-selector-module-scss-module__dNxM5q__skipLink",
  "title": "tour-selector-module-scss-module__dNxM5q__title",
});
